import { render, staticRenderFns } from "./CollapsibleCardWidget.vue?vue&type=template&id=c0eafad2&scoped=true"
import script from "./CollapsibleCardWidget.vue?vue&type=script&lang=ts"
export * from "./CollapsibleCardWidget.vue?vue&type=script&lang=ts"
import style0 from "./CollapsibleCardWidget.vue?vue&type=style&index=0&id=c0eafad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0eafad2",
  null
  
)

export default component.exports